import React from 'react';
import CorePage from './CorePage';
import UserStore from '../../util/UserStore';
import UrlManager from '../../model/UrlManager';
import HmEventRegistry from '../../model/HmEventRegistry';
import HawkEye from '../../util/HawkEye';
import AttributeManager from '../../util/AttributeManager';
import heyIcon from '../../images/icons/heypractest_icon.png';
import BrowserStorageUtil from '../../util/BrowserStorageUtil';
import BrowserUtil from '../../util/BrowserUtil';
import GradeRestrictionManager from '../../util/GradeRestrictionManager';
import $ from 'jquery';
import HmAjax from '../../util/HmAjax';

export default class PreLoginPage extends CorePage{
	constructor(props) {
		super(props);
		this.state = {loggedIn:false};

		this.UserStore = new UserStore();
		this.userObj = {};
		this.plpTrackKey = "PLP_TRACK";
		
		this.userObj = this.UserStore.get();
		
		this.plpTrackKey = "PLP_TRACK";

		this.attributeManager = null;
		this.setAttributeManager();

		this.GradeRestrictionManager = new GradeRestrictionManager();
	}

	/**
	* IMPORTANT: Applicable only to PreloginPage. This function needs to be called in places where reloading a page is NOT applicable and attribute has to be updated on the callback of post-login
	*/
	setAttributeManager(userObj){
		if(this.userObj){
			this.attributeManager = new AttributeManager(this.UserStore);	
			HmEventRegistry.fireEvent("SET_TRACK_STORE",this.UserStore);
		}else if(userObj){
			this.userObj = userObj;
			this.attributeManager = new AttributeManager(this.UserStore);	
			HmEventRegistry.fireEvent("SET_TRACK_STORE",this.UserStore);
		}else if(this.getUser().getUserId()){
			this.userObj = this.getUser();
			this.attributeManager = new AttributeManager(this.UserStore);	
			HmEventRegistry.fireEvent("SET_TRACK_STORE",this.UserStore);
		}
	}

	getGeo(){
	    return (this.getUser().getLoginId()) ? this.getUser().getGeo(): super.getGeo();
	}

	getAttributeManager(){
		if(!this.attributeManager){
			this.setAttributeManager();
		}

	    return this.attributeManager;
	}


	componentDidMount(){
		this.initiateFreshChat();
	}

	getCmpHelper(){
		return super.getCmpHelper(this.UserStore);
	}

	getComponent(cmpName){
		return this.getCmpHelper().getCmp(cmpName);
	}

	updateUserType(successCallback, failureCallBack){
		var me=this;

		var success = function(userObj){
			if(typeof userObj === "object" && userObj.userId){
				me.getUser().set(userObj);
				me.userObj=userObj;
				me.setAttributeManager(userObj);
			}

			if(typeof successCallback === "function"){
				successCallback.apply(this, [userObj]);
			}
		}
		var failure = function(error){
			if(typeof failureCallBack === "function"){
				failureCallBack.apply(this, [error]);
			}
		}

		new HmAjax(this.getUrlFor("GET_USER_TYPE")).get(success,failure);
	}

	fireMobileToast(){
		if(this.isMobile() || this.isTab()){
			var mode = 0;
			try{
				if(this.UserStore && this.UserStore.getAuthProviderId()){
					if(mode === 4){
						mode = this.getUser().getAuthProviderId();
					}
				}
			}catch(e){}
			if(this.getUser().getUserId()){
				console.log("user available ",this.getUser().getUserId())
				this.fireEvent("DESKTOP_EXP_TOAST",{msg:"warn_desktop_experience_"+mode,level:"warn"});
			}else{
				this.fireEvent("DESKTOP_EXP_TOAST",{msg:"warn_desktop_preexperience_"+mode,level:"warn"});
			}
		}
	}

	
	initiateFreshChat(){
		let disabledSites = window.noFreshChatSchoolIds || [];
		if(disabledSites.length > 0){
			let schoolId = this.getUser().getSchoolId();

			if(schoolId > 0 && disabledSites.indexOf(schoolId) > -1){
				return;
			}
		}

		HmEventRegistry.fireEvent("INIT_FRESHCHAT");				
	}
	

	doLumosLogout(success=null, failure=null){
		var me = this;
		console.log("logout url="+me.getUrlFor("LUMOS_LOGOUT"));
		$.ajax({
			url: me.getUrlFor("LUMOS_LOGOUT"),	            
			type: 'GET',
			xhrFields: {
				withCredentials: true
			},
			crossDomain: true,
			success: function(response){	            	
				if(typeof success === "function"){
					success.apply(this, [response]);
				}
			},
			error: function(response){
				console.log("Error in LUMOS_LOGOUT",response);
				if(typeof failure === "function"){
					failure.apply(this,[response]);
				}
			}
		});
	}

	doPLPLogout(success=null, failure=null){
		var me = this;
		var callBackSuccess = function(resp){
			if(typeof success === "function"){
				success.apply(this, [resp]);
			}
		}

		var callBackFailure = function(resp){
			console.error("Logout failed.");
			if(typeof failure === "function"){
				failure.apply(this,[resp]);
			}
		}
		new HmAjax(me.getUrlFor("LOGOUT")).get(callBackSuccess,callBackFailure);
	}

	sessionCheck(successCallback=null,failureCallback=null, forceTrigger=true){
		var me = this;
		var success = function(userObj){
			if(typeof userObj === "object" && userObj.authToken){
				//Update the userStore Object
				me.UserStore.set(userObj);
				//Updating the locale for the user
				me.setLocale(me.UserStore.getLocale());

				me.setState({loggedIn:true});
				me.userObj=userObj;
				me.trackPending();

				//Appending user params to FreshChat
				HmEventRegistry.fireEvent("ADD_USER_FRESHCHAT", me.UserStore);
				
				if(typeof successCallback === "function"){
					successCallback.apply(this,[userObj]);
				}
				//HmEventRegistry.fireEvent("GO_HOME",userObj);  

			}else{
				//Clear userStore
				me.UserStore.clearOldUser();
				me.trackPending();

				//Clear FreshChat user
				HmEventRegistry.fireEvent("CLEAR_USER_FRESHCHAT");

				if(typeof failureCallback === "function"){
					failureCallback.apply(this,[userObj]);
				}
				//me.initiateFreshChat();
			}
		}

		var failure = function(error){
			//empty function for now
			//me.initiateFreshChat();

			//Clear FreshChat user
			HmEventRegistry.fireEvent("CLEAR_USER_FRESHCHAT");
		}

		super.sessionCheck(success,failure, forceTrigger);
	}
	
	
	trackPending(){
		try{
			var plpTrackEvents = JSON.parse(BrowserStorageUtil.getStoredSessionItem(this.plpTrackKey));
			//console.log("loginInfo:::",loginInfo);
			var length = plpTrackEvents.length;
			if(plpTrackEvents){
				for(var i = 0; i < length; i++) {
					var trackEvent = plpTrackEvents.pop(); 
					this.initiateTrack(trackEvent.name,trackEvent.data);
					BrowserStorageUtil.storeSessionItem(this.plpTrackKey, JSON.stringify(plpTrackEvents))
				}
			}
		}catch(e){}
	}
	
	storeTrackEvent(name, data) {
		var events = JSON.parse(BrowserStorageUtil.getStoredSessionItem(this.plpTrackKey));
		events.push({name: name, data: data});
		BrowserStorageUtil.storeSessionItem(this.plpTrackKey, JSON.stringify(events));
	}

	initiateTrack(trackKey,addnldata){		
		try{
			var trackObj = this.getTracker().getEventObject(this.getTracker().eventCodes[trackKey]);
			trackObj.event_details.user_id = this.UserStore.getUserId() || "";
			trackObj.event_details.session_id = this.UserStore.getAuthToken() || "";
			trackObj.event_details.timestamp = new Date().getTime() || "";


			if(addnldata !== undefined && typeof addnldata === "object"){
				for(var key in addnldata){
					trackObj.event_data[key] = addnldata[key];
				}
			}

			var output = {"event":trackObj};
			new HawkEye(output).post();

		}catch(e){
			console.error(e);
		}
	}

	getUser(){
		return this.UserStore;
	}

	setAttribute(attrKey, attrValue, callBack){
		//if(this.attributeManager){
		if(this.getAttributeManager()){
		let oldAttrVal = this.getAttribute(attrKey);

		if(oldAttrVal === attrValue){
			if(callBack && typeof callBack === "function"){
				callBack.apply(this);
			}
		}else{
			//console.log("lala::: set attribute::",attrKey,typeof attrValue);
			this.attributeManager.update(attrKey, attrValue, callBack);	
		}		
		}
	}

	removeAttribute(attrKey, callBack){
		this.attributeManager.remove(attrKey, callBack);	
	}

	getAttribute(attrKey){
		//console.log("lala::: ", this.UserStore);
		return this.UserStore.getAttribute(attrKey);
	}
	
	render() {
		
		return(<div> {this.showLoader()} </div>)
	}
}

HmEventRegistry.registerEvent("GO_HOME",function(obj){
	window.location.href = UrlManager.getUrlForAction("LOGIN_HOME");
});



// WEBPACK FOOTER //
// ./src/views/core/PreLoginPage.js